import React from 'react';
import { ImageBackground, StyleSheet, ViewStyle } from 'react-native';

interface ScreenBackgroundProps {
  children: React.ReactNode;
  style?: ViewStyle;
}

export default function ScreenBackground({ children, style }: ScreenBackgroundProps) {
  return (
    <ImageBackground 
      source={require('../../assets/images/fondo.png')} 
      style={[styles.background, style]}
      resizeMode="cover"
    >
      {children}
    </ImageBackground>
  );
}

const styles = StyleSheet.create({
  background: {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: '#f8f9fa', // Fallback color
  }
});
